import createProjectPin from 'App/components/Map/mapPins/ProjectPin';
import createAccountAddressPin from 'App/components/Map/mapPins/AccountAddressPin';
import createCompanyPin, { type CompanyPinClient } from 'App/components/Map/mapPins/CompanyPin';
import type { SupportedPinEntity, AccountAddress, ProjectPlanType } from './MapPinTypes';

export const PIN_TYPE = {
	PROJECT_PLAN: 'PROJECT_PLAN',
	ACCOUNT_ADDRESS: 'ACCOUNT_ADDRESS',
	COMPANY: 'COMPANY'
};

export const createPin = (entity: SupportedPinEntity | CompanyPinClient, type: string) => {
	switch (type) {
		case PIN_TYPE.PROJECT_PLAN:
			return createProjectPin(entity as ProjectPlanType);
		case PIN_TYPE.ACCOUNT_ADDRESS:
			return createAccountAddressPin(entity as AccountAddress);
		case PIN_TYPE.COMPANY:
			return createCompanyPin(entity as CompanyPinClient);
		default:
			return createProjectPin(entity as ProjectPlanType);
	}
};
